import React, { useState } from 'react';
import { Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getImageUrl } from '../utils/imageUtils';

const Product = ({ product }) => {
  const { deviseInfo } = useSelector((state) => state.devise);
  const [imageError, setImageError] = useState(false);

  const currency =
    typeof deviseInfo === 'string' && deviseInfo !== '---' ? deviseInfo : 'TND';

  const priceLabel = () => {
    if (currency === 'EUR' && product.priceEur != null) return `${product.priceEur} EUR`;
    if (currency === 'USD' && product.priceDol != null) return `${product.priceDol} USD`;
    return `${product.price ?? 0} TND`;
  };

  return (
    <Card className='product-card'>
      <Link to={`/product/other/${product._id}`} className='card-img-wrap d-block'>
        <span className='product-badge'>Produit</span>
        <Card.Img
          className='product-image'
          src={imageError ? '/images/placeholder.jpg' : getImageUrl(product.image)}
          variant='top'
          onError={() => setImageError(true)}
        />
      </Link>

      <Card.Body>
        <Link to={`/product/other/${product._id}`}>
          <Card.Title className='product-title' as='div'>
            {product.name}
          </Card.Title>
        </Link>

        <div className='product-price'>{priceLabel()}</div>

        <div className='product-cta'>
          <Link to={`/product/other/${product._id}`} className='d-grid'>
            <Button className='btn-teal btn-sm'>Voir le détail</Button>
          </Link>
        </div>
      </Card.Body>
    </Card>
  );
};

export default Product;
